export const agentPresentationCopy = {
  en: {
    newAgentDraft: 'New agent · Draft',
    notCreated: 'Not created yet.',
    companyAgent: 'Company agent',
    personalAgent: 'Personal agent',
    madeBy: 'Made by {name}',
    adminsManage: '{company} · admins manage it',
    liveAuthor:
      'Version {revision} was written by {name}. Switched on, it runs as you with your private connections.',
    runsWhenCreated: 'It can run once its owner creates it.',
    onDemand: 'On demand.',
    onDemandEdit: 'It runs when someone runs it. Add a schedule under When it runs.',
    onDemandRun: 'It runs when someone runs it.',
    on: 'On.',
    nextRun: 'On. Next run {date}.',
    pausing: 'Pausing stops the schedule. Run now still works.',
    alsoRun: 'You can also run it now.',
    off: 'Off. {schedule} once it is turned on.',
    offRun: 'Run now still works while it is off.',
    saveCancel: 'Save or cancel your change first.',
    draftAuto: 'This draft does not run automatically.',
    testFirst: 'Test it once to see a real result first.',
    testChat: 'The test run is in a chat only you can read.',
    copied: 'Copied. It is yours, with a paused schedule, and runs with your own accounts.',
    editRequested: 'Edit access requested',
    switchOff: 'Switch off',
    archive: 'Archive',
    draftNotCreated: 'Draft, not created yet',
    waiting: 'Waiting for your approval',
    neverRun: 'Never run',
    lastRun: 'Last run {date}{failed}',
    lastRunOnly: 'Last run{failed}',
    formerMember: 'Former member',
    namesDeleted:
      '{schedule} · names only; its owner’s account was deleted, so admins can archive it',
    namesRuns: '{schedule} · names only; runs and Results stay with {name}',
    thisNotCreated: 'This agent has not been created yet. It can run once its owner creates it.',
    noTestRuns: 'No test runs yet. Test run tries the draft once, in a chat only you can read.',
    scheduleSaved: 'Schedule saved.',
    draftSaved: 'Draft saved.',
    savedVersion: 'Saved as version {version}.',
    onDemandNow: 'It runs on demand now.',
    you: 'You',
    anyoneCanRun: 'Anyone at {company} can run it now.',
    youRun: 'You run it when you need it.',
    alsoCompany: 'Anyone at {company} can also run it now.',
  },
  bg: {
    newAgentDraft: 'Нов агент · Чернова',
    notCreated: 'Все още не е създаден.',
    companyAgent: 'Агент на компанията',
    personalAgent: 'Личен агент',
    madeBy: 'Създаден от {name}',
    adminsManage: '{company} · администраторите го управляват',
    liveAuthor:
      'Версия {revision} е създадена от {name}. Когато е включен, агентът се изпълнява като вас с личните ви връзки.',
    runsWhenCreated: 'Може да се изпълнява, след като собственикът му го създаде.',
    onDemand: 'При поискване.',
    onDemandEdit: 'Изпълнява се, когато някой го стартира. Добавете график в „Кога се изпълнява“.',
    onDemandRun: 'Изпълнява се, когато някой го стартира.',
    on: 'Включен.',
    nextRun: 'Включен. Следващо изпълнение {date}.',
    pausing: 'Поставянето на пауза спира графика. Изпълнението сега все още работи.',
    alsoRun: 'Можете също да го изпълните сега.',
    off: 'Изключен. {schedule}, след като бъде включен.',
    offRun: 'Изпълнението сега все още работи, докато е изключен.',
    saveCancel: 'Първо запазете или отменете промяната си.',
    draftAuto: 'Тази чернова не се изпълнява автоматично.',
    testFirst: 'Първо я тествайте веднъж, за да видите реален резултат.',
    testChat: 'Пробното изпълнение е само в чат, който можете да прочетете единствено вие.',
    copied:
      'Копирано. То е ваше, с поставен на пауза график, и се изпълнява с вашите собствени акаунти.',
    editRequested: 'Поискан е достъп за редактиране',
    switchOff: 'Изключване',
    archive: 'Архивиране',
    draftNotCreated: 'Чернова, все още не е създадена',
    waiting: 'Изчаква вашето одобрение',
    neverRun: 'Никога не е изпълняван',
    lastRun: 'Последно изпълнение {date}{failed}',
    lastRunOnly: 'Последно изпълнение{failed}',
    formerMember: 'Бивш член',
    namesDeleted:
      '{schedule} · само имената; акаунтът на собственика му е изтрит, затова администраторите могат да го архивират',
    namesRuns: '{schedule} · само имената; изпълненията и Резултатите остават при {name}',
    thisNotCreated:
      'Този агент все още не е създаден. Може да се изпълнява, след като собственикът му го създаде.',
    noTestRuns:
      'Все още няма пробни изпълнения. Пробното изпълнение стартира черновата веднъж в чат, който можете да прочетете единствено вие.',
    scheduleSaved: 'Графикът е запазен.',
    draftSaved: 'Черновата е запазена.',
    savedVersion: 'Запазено като версия {version}.',
    onDemandNow: 'Вече се изпълнява при поискване.',
    you: 'Вие',
    anyoneCanRun: 'Всеки в {company} вече може да го изпълнява.',
    youRun: 'Вие го изпълнявате, когато ви потрябва.',
    alsoCompany: 'Всеки в {company} също може да го изпълнява сега.',
  },
  hr: {
    newAgentDraft: 'Novi agent · Nacrt',
    notCreated: 'Još nije izrađen.',
    companyAgent: 'Agent tvrtke',
    personalAgent: 'Osobni agent',
    madeBy: 'Autor: {name}',
    adminsManage: '{company} · njime upravljaju administratori',
    liveAuthor:
      'Verziju {revision} napisao/la je {name}. Kad se uključi, pokreće se kao vi s vašim privatnim vezama.',
    runsWhenCreated: 'Može se pokretati čim ga vlasnik izradi.',
    onDemand: 'Na zahtjev.',
    onDemandEdit: 'Pokreće se kad ga netko pokrene. Dodajte raspored u odjeljak Kada se pokreće.',
    onDemandRun: 'Pokreće se kad ga netko pokrene.',
    on: 'Uključeno.',
    nextRun: 'Uključeno. Sljedeće pokretanje {date}.',
    pausing: 'Pauziranje zaustavlja raspored. Pokretanje odmah i dalje funkcionira.',
    alsoRun: 'Možete ga pokrenuti i sada.',
    off: 'Isključeno. {schedule} nakon uključivanja.',
    offRun: 'Pokretanje odmah i dalje funkcionira dok je isključeno.',
    saveCancel: 'Najprije spremite ili otkažite promjenu.',
    draftAuto: 'Ovaj se nacrt ne pokreće automatski.',
    testFirst: 'Najprije ga jednom testirajte da biste vidjeli stvarni rezultat.',
    testChat: 'Testno pokretanje nalazi se u chatu koji možete čitati samo vi.',
    copied: 'Kopirano. Sada je vaš, s pauziranim rasporedom, i pokreće se s vašim računima.',
    editRequested: 'Zatražen pristup uređivanju',
    switchOff: 'Isključi',
    archive: 'Arhiviraj',
    draftNotCreated: 'Nacrt, još nije izrađen',
    waiting: 'Čeka vaše odobrenje',
    neverRun: 'Nikad pokrenuto',
    lastRun: 'Posljednje pokretanje {date}{failed}',
    lastRunOnly: 'Posljednje pokretanje{failed}',
    formerMember: 'Bivši član',
    namesDeleted:
      '{schedule} · samo nazivi; vlasnički račun je izbrisan, pa ga administratori mogu arhivirati',
    namesRuns: '{schedule} · samo nazivi; pokretanja i Rezultati ostaju uz {name}',
    thisNotCreated: 'Ovaj agent još nije izrađen. Može se pokretati čim ga vlasnik izradi.',
    noTestRuns:
      'Još nema testnih pokretanja. Testno pokretanje jednom pokreće nacrt u chatu koji možete čitati samo vi.',
    scheduleSaved: 'Raspored je spremljen.',
    draftSaved: 'Nacrt je spremljen.',
    savedVersion: 'Spremljeno kao verzija {version}.',
    onDemandNow: 'Sada se pokreće na zahtjev.',
    you: 'Vi',
    anyoneCanRun: 'Svatko u tvrtki {company} sada ga može pokrenuti.',
    youRun: 'Pokrećete ga kad vam zatreba.',
    alsoCompany: 'Svatko u tvrtki {company} sada ga također može pokrenuti.',
  },
  cs: {
    newAgentDraft: 'Nový agent · koncept',
    notCreated: 'Zatím nebyl vytvořen.',
    companyAgent: 'Firemní agent',
    personalAgent: 'Osobní agent',
    madeBy: 'Vytvořil(a) {name}',
    adminsManage: '{company} · spravují ho administrátoři',
    liveAuthor:
      'Verzi {revision} vytvořil(a) {name}. Po zapnutí běží jako vy s vašimi soukromými připojeními.',
    runsWhenCreated: 'Může běžet, jakmile ho jeho vlastník vytvoří.',
    onDemand: 'Na vyžádání.',
    onDemandEdit: 'Spustí se, když ho někdo spustí. Přidejte plán v části Kdy se spouští.',
    onDemandRun: 'Spustí se, když ho někdo spustí.',
    on: 'Zapnuto.',
    nextRun: 'Zapnuto. Další spuštění {date}.',
    pausing: 'Pozastavení zastaví plán. Spuštění nyní bude dál fungovat.',
    alsoRun: 'Můžete ho také spustit nyní.',
    off: 'Vypnuto. {schedule} po zapnutí.',
    offRun: 'Spuštění nyní bude fungovat i při vypnutí.',
    saveCancel: 'Nejprve uložte nebo zrušte změnu.',
    draftAuto: 'Tento koncept se nespouští automaticky.',
    testFirst: 'Nejprve ho jednou otestujte, abyste viděli skutečný výsledek.',
    testChat: 'Testovací spuštění proběhne v chatu, který můžete číst jen vy.',
    copied: 'Zkopírováno. Je váš, s pozastaveným plánem, a běží s vašimi vlastními účty.',
    editRequested: 'Požadavek na přístup k úpravám',
    switchOff: 'Vypnout',
    archive: 'Archivovat',
    draftNotCreated: 'Koncept, zatím nebyl vytvořen',
    waiting: 'Čeká na vaše schválení',
    neverRun: 'Nikdy nespouštěno',
    lastRun: 'Poslední spuštění {date}{failed}',
    lastRunOnly: 'Poslední spuštění{failed}',
    formerMember: 'Bývalý člen',
    namesDeleted:
      '{schedule} · pouze názvy; účet jeho vlastníka byl smazán, takže ho mohou administrátoři archivovat',
    namesRuns: '{schedule} · pouze názvy; spuštění a výsledky zůstávají u uživatele {name}',
    thisNotCreated:
      'Tento agent ještě nebyl vytvořen. Může běžet, jakmile ho jeho vlastník vytvoří.',
    noTestRuns:
      'Zatím žádná testovací spuštění. Testovací spuštění zkusí koncept jednou v chatu, který můžete číst jen vy.',
    scheduleSaved: 'Plán uložen.',
    draftSaved: 'Koncept uložen.',
    savedVersion: 'Uloženo jako verze {version}.',
    onDemandNow: 'Nyní se spouští na vyžádání.',
    you: 'Vy',
    anyoneCanRun: 'Kdokoli v organizaci {company} ho nyní může spustit.',
    youRun: 'Spouštíte ho, když ho potřebujete.',
    alsoCompany: 'Kdokoli v organizaci {company} ho nyní může také spustit.',
  },
  da: {
    newAgentDraft: 'Ny agent · Kladde',
    notCreated: 'Ikke oprettet endnu.',
    companyAgent: 'Virksomhedsagent',
    personalAgent: 'Personlig agent',
    madeBy: 'Oprettet af {name}',
    adminsManage: '{company} · administratorer administrerer den',
    liveAuthor:
      'Version {revision} er skrevet af {name}. Når den er slået til, kører den som dig med dine private forbindelser.',
    runsWhenCreated: 'Den kan køre, når ejeren har oprettet den.',
    onDemand: 'Efter behov.',
    onDemandEdit: 'Den kører, når nogen kører den. Tilføj en tidsplan under Hvornår den kører.',
    onDemandRun: 'Den kører, når nogen kører den.',
    on: 'Til.',
    nextRun: 'Til. Næste kørsel {date}.',
    pausing: 'Hvis du sætter den på pause, stopper tidsplanen. Kør nu fungerer stadig.',
    alsoRun: 'Du kan også køre den nu.',
    off: 'Fra. {schedule}, når den er slået til.',
    offRun: 'Kør nu fungerer stadig, når den er slået fra.',
    saveCancel: 'Gem eller annuller din ændring først.',
    draftAuto: 'Denne kladde kører ikke automatisk.',
    testFirst: 'Test den én gang for at se et rigtigt resultat først.',
    testChat: 'Testkørslen er kun synlig for dig i en chat.',
    copied: 'Kopieret. Den er din med en sat på pause-tidsplan og kører med dine egne konti.',
    editRequested: 'Anmodning om redigeringsadgang',
    switchOff: 'Slå fra',
    archive: 'Arkivér',
    draftNotCreated: 'Kladde, endnu ikke oprettet',
    waiting: 'Afventer din godkendelse',
    neverRun: 'Aldrig kørt',
    lastRun: 'Senest kørt {date}{failed}',
    lastRunOnly: 'Senest kørt{failed}',
    formerMember: 'Tidligere medlem',
    namesDeleted:
      '{schedule} · kun navne; ejerens konto blev slettet, så administratorer kan arkivere den',
    namesRuns: '{schedule} · kun navne; kørsler og resultater forbliver hos {name}',
    thisNotCreated:
      'Denne agent er endnu ikke oprettet. Den kan køre, når ejeren har oprettet den.',
    noTestRuns:
      'Ingen testkørsler endnu. En testkørsel prøver kladden én gang i en chat, som kun du kan læse.',
    scheduleSaved: 'Tidsplan gemt.',
    draftSaved: 'Kladde gemt.',
    savedVersion: 'Gemt som version {version}.',
    onDemandNow: 'Den kører nu efter behov.',
    you: 'Dig',
    anyoneCanRun: 'Alle hos {company} kan køre den nu.',
    youRun: 'Du kører den, når du har brug for det.',
    alsoCompany: 'Alle hos {company} kan også køre den nu.',
  },
  nl: {
    newAgentDraft: 'Nieuwe agent · Concept',
    notCreated: 'Nog niet aangemaakt.',
    companyAgent: 'Bedrijfsagent',
    personalAgent: 'Persoonlijke agent',
    madeBy: 'Gemaakt door {name}',
    adminsManage: '{company} · wordt beheerd door beheerders',
    liveAuthor:
      'Versie {revision} is geschreven door {name}. Ingeschakeld wordt deze uitgevoerd als jij, met je privéverbindingen.',
    runsWhenCreated: 'De agent kan worden uitgevoerd zodra de eigenaar deze aanmaakt.',
    onDemand: 'Op aanvraag.',
    onDemandEdit:
      'De agent wordt uitgevoerd wanneer iemand deze uitvoert. Voeg een planning toe onder Wanneer de agent wordt uitgevoerd.',
    onDemandRun: 'De agent wordt uitgevoerd wanneer iemand deze uitvoert.',
    on: 'Aan.',
    nextRun: 'Aan. Volgende uitvoering {date}.',
    pausing: 'Pauzeren stopt de planning. Nu uitvoeren blijft werken.',
    alsoRun: 'Je kunt de agent ook nu uitvoeren.',
    off: 'Uit. {schedule} zodra de agent wordt ingeschakeld.',
    offRun: 'Nu uitvoeren blijft werken wanneer de agent uitstaat.',
    saveCancel: 'Sla je wijziging eerst op of annuleer deze.',
    draftAuto: 'Dit concept wordt niet automatisch uitgevoerd.',
    testFirst: 'Test de agent één keer om eerst een echt resultaat te zien.',
    testChat: 'De testuitvoering staat in een chat die alleen jij kunt lezen.',
    copied:
      'Gekopieerd. De agent is van jou, met een gepauzeerde planning, en wordt uitgevoerd met je eigen accounts.',
    editRequested: 'Toegang om te bewerken aangevraagd',
    switchOff: 'Uitschakelen',
    archive: 'Archiveren',
    draftNotCreated: 'Concept, nog niet aangemaakt',
    waiting: 'Wacht op je goedkeuring',
    neverRun: 'Nooit uitgevoerd',
    lastRun: 'Laatste uitvoering {date}{failed}',
    lastRunOnly: 'Laatste uitvoering{failed}',
    formerMember: 'Voormalig lid',
    namesDeleted:
      '{schedule} · alleen namen; het account van de eigenaar is verwijderd, dus beheerders kunnen de agent archiveren',
    namesRuns: '{schedule} · alleen namen; uitvoeringen en Resultaten blijven bij {name}',
    thisNotCreated:
      'Deze agent is nog niet aangemaakt. De agent kan worden uitgevoerd zodra de eigenaar deze aanmaakt.',
    noTestRuns:
      'Nog geen testuitvoeringen. Met Testen wordt het concept één keer uitgevoerd, in een chat die alleen jij kunt lezen.',
    scheduleSaved: 'Planning opgeslagen.',
    draftSaved: 'Concept opgeslagen.',
    savedVersion: 'Opgeslagen als versie {version}.',
    onDemandNow: 'De agent wordt nu op aanvraag uitgevoerd.',
    you: 'Jij',
    anyoneCanRun: 'Iedereen bij {company} kan de agent nu uitvoeren.',
    youRun: 'Je voert de agent uit wanneer je deze nodig hebt.',
    alsoCompany: 'Iedereen bij {company} kan de agent nu ook uitvoeren.',
  },
  et: {
    newAgentDraft: 'Uus agent · mustand',
    notCreated: 'Pole veel loodud.',
    companyAgent: 'Ettevõtte agent',
    personalAgent: 'Isiklik agent',
    madeBy: 'Koostaja: {name}',
    adminsManage: '{company} · administraatorid haldavad seda',
    liveAuthor:
      'Versiooni {revision} koostas {name}. Sisselülitatuna töötab see sinu nimel ja sinu privaatsete ühendustega.',
    runsWhenCreated: 'See saab käivituda, kui omanik selle loob.',
    onDemand: 'Nõudmisel.',
    onDemandEdit: 'See käivitub, kui keegi selle käivitab. Lisa ajakava jaotises „Käivitamisaeg“ .',
    onDemandRun: 'See käivitub, kui keegi selle käivitab.',
    on: 'Sees.',
    nextRun: 'Sees. Järgmine käivitus {date}.',
    pausing: 'Paus peatab ajakava. Kohe käivitamine töötab endiselt.',
    alsoRun: 'Saad selle ka kohe käivitada.',
    off: 'Väljas. {schedule}, kui see sisse lülitatakse.',
    offRun: 'Kohe käivitamine töötab ka siis, kui see on väljas.',
    saveCancel: 'Salvesta või tühista muudatus enne jätkamist.',
    draftAuto: 'See mustand ei käivitu automaatselt.',
    testFirst: 'Tee esmalt üks testkäivitus, et näha tegelikku tulemust.',
    testChat: 'Testkäivitus toimub vestluses, mida ainult sina saad lugeda.',
    copied: 'Kopeeritud. See on nüüd sinu oma, peatatud ajakavaga, ja töötab sinu kontodega.',
    editRequested: 'Muutmisõiguse taotlus',
    switchOff: 'Lülita välja',
    archive: 'Arhiveeri',
    draftNotCreated: 'Mustand, pole veel loodud',
    waiting: 'Ootab sinu kinnitust',
    neverRun: 'Pole kunagi käivitatud',
    lastRun: 'Viimati käitatud {date}{failed}',
    lastRunOnly: 'Viimati käitatud{failed}',
    formerMember: 'Endine liige',
    namesDeleted:
      '{schedule} · ainult nimed; selle omaniku konto kustutati, seega saavad administraatorid selle arhiveerida',
    namesRuns: '{schedule} · ainult nimed; käivitused ja tulemused jäävad kasutajale {name}',
    thisNotCreated: 'Seda agenti pole veel loodud. See saab käivituda, kui omanik selle loob.',
    noTestRuns:
      'Testkäivitusi pole veel tehtud. Testkäivitus proovib mustandit üks kord vestluses, mida ainult sina saad lugeda.',
    scheduleSaved: 'Ajakava on salvestatud.',
    draftSaved: 'Mustand on salvestatud.',
    savedVersion: 'Salvestatud versioonina {version}.',
    onDemandNow: 'Nüüd käivitub see nõudmisel.',
    you: 'Sina',
    anyoneCanRun: 'Kõik ettevõtte {company} liikmed saavad seda nüüd käivitada.',
    youRun: 'Käivitad selle siis, kui vajad.',
    alsoCompany: 'Kõik ettevõtte {company} liikmed saavad seda nüüd samuti käivitada.',
  },
  fi: {
    newAgentDraft: 'Uusi agentti · Luonnos',
    notCreated: 'Ei vielä luotu.',
    companyAgent: 'Yrityksen agentti',
    personalAgent: 'Henkilökohtainen agentti',
    madeBy: 'Tekijä: {name}',
    adminsManage: '{company} · ylläpitäjät hallinnoivat sitä',
    liveAuthor:
      'Version {revision} kirjoitti {name}. Käytössä se suoritetaan sinuna yksityisiä yhteyksiäsi käyttäen.',
    runsWhenCreated: 'Se voidaan suorittaa, kun sen omistaja luo sen.',
    onDemand: 'Tarvittaessa.',
    onDemandEdit:
      'Se suoritetaan, kun joku suorittaa sen. Lisää ajoitus kohdassa Suoritusajankohta.',
    onDemandRun: 'Se suoritetaan, kun joku suorittaa sen.',
    on: 'Käytössä.',
    nextRun: 'Käytössä. Seuraava suoritus {date}.',
    pausing: 'Keskeyttäminen pysäyttää ajoituksen. Voit silti suorittaa sen nyt.',
    alsoRun: 'Voit myös suorittaa sen nyt.',
    off: 'Pois käytöstä. {schedule}, kun se otetaan käyttöön.',
    offRun: 'Voit silti suorittaa sen nyt, vaikka se on pois käytöstä.',
    saveCancel: 'Tallenna muutos tai peruuta se ensin.',
    draftAuto: 'Tätä luonnosta ei suoriteta automaattisesti.',
    testFirst: 'Testaa se ensin kerran nähdäksesi todellisen tuloksen.',
    testChat: 'Testiajo on keskustelussa, jonka vain sinä voit lukea.',
    copied:
      'Kopioitu. Se on sinun, sen ajoitus on keskeytetty, ja se suoritetaan omilla tileilläsi.',
    editRequested: 'Muokkausoikeutta pyydetty',
    switchOff: 'Poista käytöstä',
    archive: 'Arkistoi',
    draftNotCreated: 'Luonnos, ei vielä luotu',
    waiting: 'Odottaa hyväksyntääsi',
    neverRun: 'Ei koskaan suoritettu',
    lastRun: 'Viimeksi suoritettu {date}{failed}',
    lastRunOnly: 'Viimeksi suoritettu{failed}',
    formerMember: 'Entinen jäsen',
    namesDeleted:
      '{schedule} · vain nimet; sen omistajan tili poistettiin, joten ylläpitäjät voivat arkistoida sen',
    namesRuns: '{schedule} · vain nimet; ajot ja Tulokset säilyvät käyttäjällä {name}',
    thisNotCreated:
      'Tätä agenttia ei ole vielä luotu. Se voidaan suorittaa, kun sen omistaja luo sen.',
    noTestRuns:
      'Ei testiajoja vielä. Testiajo suorittaa luonnoksen kerran keskustelussa, jonka vain sinä voit lukea.',
    scheduleSaved: 'Ajoitus tallennettu.',
    draftSaved: 'Luonnos tallennettu.',
    savedVersion: 'Tallennettu versiona {version}.',
    onDemandNow: 'Se suoritetaan nyt tarvittaessa.',
    you: 'Sinä',
    anyoneCanRun: 'Kuka tahansa yrityksessä {company} voi suorittaa sen nyt.',
    youRun: 'Sinä suoritat sen, kun tarvitset sitä.',
    alsoCompany: 'Kuka tahansa yrityksessä {company} voi myös suorittaa sen nyt.',
  },
  fr: {
    newAgentDraft: 'Nouvel agent · Brouillon',
    notCreated: 'Pas encore créé.',
    companyAgent: 'Agent de l’entreprise',
    personalAgent: 'Agent personnel',
    madeBy: 'Créé par {name}',
    adminsManage: '{company} · les administrateurs le gèrent',
    liveAuthor:
      'La version {revision} a été rédigée par {name}. Une fois activée, elle s’exécute en votre nom avec vos connexions privées.',
    runsWhenCreated: 'Il peut s’exécuter dès que son propriétaire l’a créé.',
    onDemand: 'À la demande.',
    onDemandEdit:
      'Il s’exécute lorsque quelqu’un le lance. Ajoutez une planification dans « Quand il s’exécute ».',
    onDemandRun: 'Il s’exécute lorsque quelqu’un le lance.',
    on: 'Activé.',
    nextRun: 'Activé. Prochaine exécution : {date}.',
    pausing: 'La mise en pause arrête la planification. L’exécution immédiate reste possible.',
    alsoRun: 'Vous pouvez également l’exécuter maintenant.',
    off: 'Désactivé. {schedule} une fois activé.',
    offRun: 'L’exécution immédiate reste possible lorsqu’il est désactivé.',
    saveCancel: 'Enregistrez ou annulez d’abord votre modification.',
    draftAuto: 'Ce brouillon ne s’exécute pas automatiquement.',
    testFirst: 'Testez-le une fois pour voir d’abord un résultat réel.',
    testChat: 'L’exécution de test se trouve dans une conversation que vous seul pouvez lire.',
    copied:
      'Copié. Il est à vous, avec une planification en pause, et s’exécute avec vos propres comptes.',
    editRequested: 'Demande d’accès à la modification',
    switchOff: 'Désactiver',
    archive: 'Archiver',
    draftNotCreated: 'Brouillon, pas encore créé',
    waiting: 'En attente de votre approbation',
    neverRun: 'Jamais exécuté',
    lastRun: 'Dernière exécution {date}{failed}',
    lastRunOnly: 'Dernière exécution{failed}',
    formerMember: 'Ancien membre',
    namesDeleted:
      '{schedule} · noms uniquement ; le compte de son propriétaire a été supprimé, les administrateurs peuvent donc l’archiver',
    namesRuns:
      '{schedule} · noms uniquement ; les exécutions et les résultats restent associés à {name}',
    thisNotCreated:
      'Cet agent n’a pas encore été créé. Il peut s’exécuter dès que son propriétaire l’a créé.',
    noTestRuns:
      'Aucune exécution de test pour le moment. L’exécution de test essaie le brouillon une fois, dans une conversation que vous seul pouvez lire.',
    scheduleSaved: 'Planification enregistrée.',
    draftSaved: 'Brouillon enregistré.',
    savedVersion: 'Enregistré en tant que version {version}.',
    onDemandNow: 'Il s’exécute désormais à la demande.',
    you: 'Vous',
    anyoneCanRun: 'Toute personne chez {company} peut maintenant l’exécuter.',
    youRun: 'Vous l’exécutez lorsque vous en avez besoin.',
    alsoCompany: 'Toute personne chez {company} peut également l’exécuter maintenant.',
  },
  de: {
    newAgentDraft: 'Neuer Agent · Entwurf',
    notCreated: 'Noch nicht erstellt.',
    companyAgent: 'Unternehmensagent',
    personalAgent: 'Persönlicher Agent',
    madeBy: 'Erstellt von {name}',
    adminsManage: '{company} · von Admins verwaltet',
    liveAuthor:
      'Version {revision} wurde von {name} verfasst. Aktiviert läuft sie in Ihrem Namen mit Ihren privaten Verbindungen.',
    runsWhenCreated: 'Der Agent kann ausgeführt werden, sobald sein Besitzer ihn erstellt.',
    onDemand: 'Auf Abruf.',
    onDemandEdit:
      'Er läuft, wenn ihn jemand ausführt. Fügen Sie unter „Ausführung“ einen Zeitplan hinzu.',
    onDemandRun: 'Er läuft, wenn ihn jemand ausführt.',
    on: 'Ein.',
    nextRun: 'Ein. Nächste Ausführung {date}.',
    pausing:
      'Durch Pausieren wird der Zeitplan angehalten. „Jetzt ausführen“ funktioniert weiterhin.',
    alsoRun: 'Sie können ihn auch jetzt ausführen.',
    off: 'Aus. {schedule}, sobald er aktiviert ist.',
    offRun: '„Jetzt ausführen“ funktioniert weiterhin, solange er deaktiviert ist.',
    saveCancel: 'Speichern Sie Ihre Änderung zuerst oder brechen Sie sie ab.',
    draftAuto: 'Dieser Entwurf wird nicht automatisch ausgeführt.',
    testFirst: 'Führen Sie ihn einmal testweise aus, um zuerst ein echtes Ergebnis zu sehen.',
    testChat: 'Der Testlauf findet in einem Chat statt, den nur Sie lesen können.',
    copied:
      'Kopiert. Er gehört Ihnen, hat einen pausierten Zeitplan und läuft mit Ihren eigenen Konten.',
    editRequested: 'Bearbeitungszugriff angefordert',
    switchOff: 'Deaktivieren',
    archive: 'Archivieren',
    draftNotCreated: 'Entwurf, noch nicht erstellt',
    waiting: 'Wartet auf Ihre Genehmigung',
    neverRun: 'Noch nie ausgeführt',
    lastRun: 'Letzte Ausführung {date}{failed}',
    lastRunOnly: 'Letzte Ausführung{failed}',
    formerMember: 'Ehemaliges Mitglied',
    namesDeleted:
      '{schedule} · nur Namen; das Konto des Besitzers wurde gelöscht, daher können Admins ihn archivieren',
    namesRuns: '{schedule} · nur Namen; Ausführungen und Ergebnisse bleiben bei {name}',
    thisNotCreated:
      'Dieser Agent wurde noch nicht erstellt. Er kann ausgeführt werden, sobald sein Besitzer ihn erstellt.',
    noTestRuns:
      'Noch keine Testläufe. Beim Testlauf wird der Entwurf einmal in einem Chat ausgeführt, den nur Sie lesen können.',
    scheduleSaved: 'Zeitplan gespeichert.',
    draftSaved: 'Entwurf gespeichert.',
    savedVersion: 'Als Version {version} gespeichert.',
    onDemandNow: 'Er läuft jetzt auf Abruf.',
    you: 'Sie',
    anyoneCanRun: 'Jetzt kann jeder bei {company} ihn ausführen.',
    youRun: 'Sie führen ihn aus, wenn Sie ihn brauchen.',
    alsoCompany: 'Jetzt kann ihn auch jeder bei {company} ausführen.',
  },
  el: {
    newAgentDraft: 'Νέος πράκτορας · Πρόχειρο',
    notCreated: 'Δεν έχει δημιουργηθεί ακόμη.',
    companyAgent: 'Εταιρικός πράκτορας',
    personalAgent: 'Προσωπικός πράκτορας',
    madeBy: 'Δημιουργήθηκε από τον/την {name}',
    adminsManage: '{company} · η διαχείριση γίνεται από διαχειριστές',
    liveAuthor:
      'Η έκδοση {revision} γράφτηκε από τον/την {name}. Όταν είναι ενεργός, εκτελείται ως εσύ, με τις ιδιωτικές σου συνδέσεις.',
    runsWhenCreated: 'Μπορεί να εκτελεστεί μόλις τον δημιουργήσει ο κάτοχός του.',
    onDemand: 'Κατά απαίτηση.',
    onDemandEdit:
      'Εκτελείται όταν τον εκτελεί κάποιος. Πρόσθεσε πρόγραμμα στην ενότητα «Πότε εκτελείται».',
    onDemandRun: 'Εκτελείται όταν τον εκτελεί κάποιος.',
    on: 'Ενεργός.',
    nextRun: 'Ενεργός. Επόμενη εκτέλεση {date}.',
    pausing: 'Η παύση σταματά το πρόγραμμα. Η εκτέλεση τώρα εξακολουθεί να λειτουργεί.',
    alsoRun: 'Μπορείς επίσης να τον εκτελέσεις τώρα.',
    off: 'Ανενεργός. {schedule} μόλις ενεργοποιηθεί.',
    offRun: 'Η εκτέλεση τώρα εξακολουθεί να λειτουργεί όσο είναι ανενεργός.',
    saveCancel: 'Αποθήκευσε ή ακύρωσε πρώτα την αλλαγή σου.',
    draftAuto: 'Αυτό το πρόχειρο δεν εκτελείται αυτόματα.',
    testFirst: 'Κάνε πρώτα μία δοκιμαστική εκτέλεση για να δεις ένα πραγματικό αποτέλεσμα.',
    testChat: 'Η δοκιμαστική εκτέλεση βρίσκεται σε συνομιλία που μόνο εσύ μπορείς να διαβάσεις.',
    copied:
      'Αντιγράφηκε. Είναι δικός σου, με πρόγραμμα σε παύση, και εκτελείται με τους δικούς σου λογαριασμούς.',
    editRequested: 'Ζητήθηκε πρόσβαση επεξεργασίας',
    switchOff: 'Απενεργοποίηση',
    archive: 'Αρχειοθέτηση',
    draftNotCreated: 'Πρόχειρο, δεν έχει δημιουργηθεί ακόμη',
    waiting: 'Αναμονή για την έγκρισή σου',
    neverRun: 'Δεν έχει εκτελεστεί ποτέ',
    lastRun: 'Τελευταία εκτέλεση {date}{failed}',
    lastRunOnly: 'Τελευταία εκτέλεση{failed}',
    formerMember: 'Πρώην μέλος',
    namesDeleted:
      '{schedule} · εμφανίζονται μόνο τα ονόματα· ο λογαριασμός του κατόχου διαγράφηκε, επομένως οι διαχειριστές μπορούν να το αρχειοθετήσουν',
    namesRuns:
      '{schedule} · εμφανίζονται μόνο τα ονόματα· οι εκτελέσεις και τα αποτελέσματα παραμένουν στον/στην {name}',
    thisNotCreated:
      'Αυτός ο πράκτορας δεν έχει δημιουργηθεί ακόμη. Μπορεί να εκτελεστεί μόλις τον δημιουργήσει ο κάτοχός του.',
    noTestRuns:
      'Δεν υπάρχουν ακόμη δοκιμαστικές εκτελέσεις. Η δοκιμαστική εκτέλεση επιχειρεί να εκτελέσει το πρόχειρο μία φορά, σε συνομιλία που μόνο εσύ μπορείς να διαβάσεις.',
    scheduleSaved: 'Το πρόγραμμα αποθηκεύτηκε.',
    draftSaved: 'Το πρόχειρο αποθηκεύτηκε.',
    savedVersion: 'Αποθηκεύτηκε ως έκδοση {version}.',
    onDemandNow: 'Πλέον εκτελείται κατά απαίτηση.',
    you: 'Εσύ',
    anyoneCanRun: 'Οποιοσδήποτε στην {company} μπορεί πλέον να τον εκτελέσει.',
    youRun: 'Τον εκτελείς όταν τον χρειάζεσαι.',
    alsoCompany: 'Οποιοσδήποτε στην {company} μπορεί επίσης να τον εκτελέσει τώρα.',
  },
  hu: {
    newAgentDraft: 'Új ügynök · Piszkozat',
    notCreated: 'Még nincs létrehozva.',
    companyAgent: 'Vállalati ügynök',
    personalAgent: 'Személyes ügynök',
    madeBy: 'Készítette: {name}',
    adminsManage: '{company} · a rendszergazdák kezelik',
    liveAuthor:
      'A(z) {revision}. verziót {name} írta. Bekapcsolva úgy fut, mint te, a privát kapcsolataiddal.',
    runsWhenCreated: 'A tulajdonosa létrehozása után futtatható.',
    onDemand: 'Igény szerint.',
    onDemandEdit:
      'Akkor fut, amikor valaki futtatja. Adj hozzá ütemezést a Futtatás időpontja alatt.',
    onDemandRun: 'Akkor fut, amikor valaki futtatja.',
    on: 'Bekapcsolva.',
    nextRun: 'Bekapcsolva. Következő futtatás: {date}.',
    pausing: 'A szüneteltetés leállítja az ütemezést. A Futtatás most továbbra is működik.',
    alsoRun: 'Most is futtathatod.',
    off: 'Kikapcsolva. {schedule}, ha bekapcsolod.',
    offRun: 'Kikapcsolt állapotban is működik a Futtatás most.',
    saveCancel: 'Előbb mentsd vagy vond vissza a módosítást.',
    draftAuto: 'Ez a piszkozat nem fut automatikusan.',
    testFirst: 'Először teszteld egyszer, hogy valódi eredményt láss.',
    testChat: 'A tesztfuttatás egy olyan csevegésben zajlik, amelyet csak te olvashatsz.',
    copied: 'Lemásolva. Ez a te ügynököd, szüneteltetett ütemezéssel, és a saját fiókjaiddal fut.',
    editRequested: 'Szerkesztési hozzáférés kérve',
    switchOff: 'Kikapcsolás',
    archive: 'Archiválás',
    draftNotCreated: 'Piszkozat, még nincs létrehozva',
    waiting: 'Jóváhagyásodra vár',
    neverRun: 'Még nem futott',
    lastRun: 'Utolsó futtatás: {date}{failed}',
    lastRunOnly: 'Utolsó futtatás{failed}',
    formerMember: 'Korábbi tag',
    namesDeleted:
      '{schedule} · csak a neve látható; a tulajdonos fiókját törölték, ezért a rendszergazdák archiválhatják',
    namesRuns:
      '{schedule} · csak a neve látható; a futtatások és az Eredmények {name} tulajdonában maradnak',
    thisNotCreated: 'Ez az ügynök még nincs létrehozva. A tulajdonosa létrehozása után futtatható.',
    noTestRuns:
      'Még nincsenek tesztfuttatások. A tesztfuttatás egyszer lefuttatja a piszkozatot egy olyan csevegésben, amelyet csak te olvashatsz.',
    scheduleSaved: 'Ütemezés mentve.',
    draftSaved: 'Piszkozat mentve.',
    savedVersion: 'Mentve {version}. verzióként.',
    onDemandNow: 'Mostantól igény szerint fut.',
    you: 'Te',
    anyoneCanRun: 'Mostantól a(z) {company} bármely tagja futtathatja.',
    youRun: 'Akkor futtatod, amikor szükséged van rá.',
    alsoCompany: 'A(z) {company} bármely tagja most is futtathatja.',
  },
  ga: {
    newAgentDraft: 'Gníomhaire nua · Dréacht',
    notCreated: 'Níl sé cruthaithe fós.',
    companyAgent: 'Gníomhaire cuideachta',
    personalAgent: 'Gníomhaire pearsanta',
    madeBy: 'Déanta ag {name}',
    adminsManage: '{company} · is iad na riarthóirí a bhainistíonn é',
    liveAuthor:
      'Scríobh {name} leagan {revision}. Nuair atá sé casta air, ritheann sé mar tusa le do naisc phríobháideacha.',
    runsWhenCreated: 'Is féidir leis rith a luaithe a chruthaíonn a úinéir é.',
    onDemand: 'Ar éileamh.',
    onDemandEdit:
      'Ritheann sé nuair a ritheann duine é. Cuir sceideal leis faoi Cathain a ritheann sé.',
    onDemandRun: 'Ritheann sé nuair a ritheann duine é.',
    on: 'Casta air.',
    nextRun: 'Casta air. An chéad rith eile {date}.',
    pausing: 'Má chuirtear ar sos é, stopann sé an sceideal. Oibríonn Rith anois fós.',
    alsoRun: 'Is féidir leat é a rith anois freisin.',
    off: 'Múchta. {schedule} nuair a chumasófar é.',
    offRun: 'Oibríonn Rith anois fós agus é múchta.',
    saveCancel: 'Sábháil nó cealaigh d’athrú ar dtús.',
    draftAuto: 'Ní ritheann an dréacht seo go huathoibríoch.',
    testFirst: 'Tástáil é uair amháin chun fíorthoradh a fheiceáil ar dtús.',
    testChat: 'Tá an rith thástála i gcomhrá nach féidir ach leat é a léamh.',
    copied:
      'Cóipeáilte. Is leatsa é, le sceideal curtha ar sos, agus ritheann sé le do chuntais féin.',
    editRequested: 'Iarradh rochtain eagarthóireachta',
    switchOff: 'Múch',
    archive: 'Cartlannaigh',
    draftNotCreated: 'Dréacht, níl sé cruthaithe fós',
    waiting: 'Ag fanacht le do cheadú',
    neverRun: 'Níor ritheadh riamh',
    lastRun: 'An rith is déanaí {date}{failed}',
    lastRunOnly: 'An rith is déanaí{failed}',
    formerMember: 'Iarbhall',
    namesDeleted:
      '{schedule} · ainmneacha amháin; scriosadh cuntas a úinéara, mar sin is féidir le riarthóirí é a chartlannú',
    namesRuns: '{schedule} · ainmneacha amháin; fanann na ritheanna agus na Torthaí le {name}',
    thisNotCreated:
      'Níl an gníomhaire seo cruthaithe fós. Is féidir leis rith a luaithe a chruthaíonn a úinéir é.',
    noTestRuns:
      'Níl aon rith thástála ann fós. Déanann an rith thástála iarracht an dréacht a rith uair amháin, i gcomhrá nach féidir ach leat é a léamh.',
    scheduleSaved: 'Sábháladh an sceideal.',
    draftSaved: 'Sábháladh an dréacht.',
    savedVersion: 'Sábháladh mar leagan {version}.',
    onDemandNow: 'Ritheann sé ar éileamh anois.',
    you: 'Tusa',
    anyoneCanRun: 'Is féidir le haon duine ag {company} é a rith anois.',
    youRun: 'Is tusa a ritheann é nuair a bhíonn sé uait.',
    alsoCompany: 'Is féidir le haon duine ag {company} é a rith anois freisin.',
  },
  it: {
    newAgentDraft: 'Nuovo agente · Bozza',
    notCreated: 'Non ancora creato.',
    companyAgent: 'Agente aziendale',
    personalAgent: 'Agente personale',
    madeBy: 'Creato da {name}',
    adminsManage: '{company} · gestito dagli amministratori',
    liveAuthor:
      'La versione {revision} è stata scritta da {name}. Quando è attivo, viene eseguito come te con le tue connessioni private.',
    runsWhenCreated: 'Può essere eseguito quando il proprietario lo crea.',
    onDemand: 'Su richiesta.',
    onDemandEdit:
      'Viene eseguito quando qualcuno lo avvia. Aggiungi una pianificazione alla voce Quando viene eseguito.',
    onDemandRun: 'Viene eseguito quando qualcuno lo avvia.',
    on: 'Attivo.',
    nextRun: 'Attivo. Prossima esecuzione {date}.',
    pausing: 'La pausa interrompe la pianificazione. Esegui ora funziona comunque.',
    alsoRun: 'Puoi anche eseguirlo ora.',
    off: 'Disattivato. {schedule} quando sarà attivato.',
    offRun: 'Esegui ora funziona comunque anche quando è disattivato.',
    saveCancel: 'Salva o annulla prima la modifica.',
    draftAuto: 'Questa bozza non viene eseguita automaticamente.',
    testFirst: 'Esegui un test per vedere prima un risultato reale.',
    testChat: "L'esecuzione di test è in una chat che solo tu puoi leggere.",
    copied: 'Copiato. È tuo, con una pianificazione in pausa, e viene eseguito con i tuoi account.',
    editRequested: 'Accesso alla modifica richiesto',
    switchOff: 'Disattiva',
    archive: 'Archivia',
    draftNotCreated: 'Bozza, non ancora creata',
    waiting: 'In attesa della tua approvazione',
    neverRun: 'Mai eseguito',
    lastRun: 'Ultima esecuzione {date}{failed}',
    lastRunOnly: 'Ultima esecuzione{failed}',
    formerMember: 'Ex membro',
    namesDeleted:
      "{schedule} · solo i nomi; l'account del proprietario è stato eliminato, quindi gli amministratori possono archiviarlo",
    namesRuns:
      '{schedule} · solo i nomi; le esecuzioni e i Risultati restano a disposizione di {name}',
    thisNotCreated:
      'Questo agente non è ancora stato creato. Può essere eseguito quando il proprietario lo crea.',
    noTestRuns:
      "Nessuna esecuzione di test. L'esecuzione di test prova la bozza una volta, in una chat che solo tu puoi leggere.",
    scheduleSaved: 'Pianificazione salvata.',
    draftSaved: 'Bozza salvata.',
    savedVersion: 'Salvato come versione {version}.',
    onDemandNow: 'Ora viene eseguito su richiesta.',
    you: 'Tu',
    anyoneCanRun: 'Chiunque in {company} può eseguirlo ora.',
    youRun: 'Lo esegui tu quando ne hai bisogno.',
    alsoCompany: 'Chiunque in {company} può anche eseguirlo ora.',
  },
  lv: {
    newAgentDraft: 'Jauns aģents · Melnraksts',
    notCreated: 'Vēl nav izveidots.',
    companyAgent: 'Uzņēmuma aģents',
    personalAgent: 'Personīgais aģents',
    madeBy: 'Izveidoja {name}',
    adminsManage: '{company} · pārvalda administratori',
    liveAuthor:
      'Versiju {revision} izveidoja {name}. Kad tā ir ieslēgta, tā darbojas jūsu vārdā, izmantojot jūsu privātos savienojumus.',
    runsWhenCreated: 'Tas var darboties, tiklīdz īpašnieks to izveido.',
    onDemand: 'Pēc pieprasījuma.',
    onDemandEdit: 'Tas darbojas, kad kāds to palaiž. Pievienojiet grafiku sadaļā Kad tas darbojas.',
    onDemandRun: 'Tas darbojas, kad kāds to palaiž.',
    on: 'Ieslēgts.',
    nextRun: 'Ieslēgts. Nākamā palaišana: {date}.',
    pausing: 'Pauzēšana aptur grafiku. Opcija “Palaist tagad” joprojām darbojas.',
    alsoRun: 'Varat to palaist arī tagad.',
    off: 'Izslēgts. {schedule}, kad tas tiks ieslēgts.',
    offRun: 'Opcija “Palaist tagad” darbojas arī tad, kad tas ir izslēgts.',
    saveCancel: 'Vispirms saglabājiet vai atceliet izmaiņas.',
    draftAuto: 'Šis melnraksts nedarbojas automātiski.',
    testFirst: 'Vispirms pārbaudiet to, lai redzētu reālu rezultātu.',
    testChat: 'Testa palaišana notiek tērzēšanā, ko varat lasīt tikai jūs.',
    copied: 'Nokopēts. Tas ir jūsu, ar pauzētu grafiku, un darbojas ar jūsu kontiem.',
    editRequested: 'Pieprasīta rediģēšanas piekļuve',
    switchOff: 'Izslēgt',
    archive: 'Arhivēt',
    draftNotCreated: 'Melnraksts, vēl nav izveidots',
    waiting: 'Gaida jūsu apstiprinājumu',
    neverRun: 'Nekad nav palaists',
    lastRun: 'Pēdējā palaišana {date}{failed}',
    lastRunOnly: 'Pēdējā palaišana{failed}',
    formerMember: 'Bijušais dalībnieks',
    namesDeleted:
      '{schedule} · tikai nosaukumi; tā īpašnieka konts tika dzēsts, tāpēc administratori to var arhivēt',
    namesRuns: '{schedule} · tikai nosaukumi; palaišanas un rezultāti paliek pie {name}',
    thisNotCreated:
      'Šis aģents vēl nav izveidots. Tas var darboties, tiklīdz īpašnieks to izveido.',
    noTestRuns:
      'Pagaidām nav testa palaišanu. Testa palaišana vienreiz izmēģina melnrakstu tērzēšanā, ko varat lasīt tikai jūs.',
    scheduleSaved: 'Grafiks saglabāts.',
    draftSaved: 'Melnraksts saglabāts.',
    savedVersion: 'Saglabāts kā versija {version}.',
    onDemandNow: 'Tagad tas darbojas pēc pieprasījuma.',
    you: 'Jūs',
    anyoneCanRun: 'Ikviens uzņēmumā {company} tagad var to palaist.',
    youRun: 'Jūs to palaižat, kad nepieciešams.',
    alsoCompany: 'Ikviens uzņēmumā {company} tagad var to arī palaist.',
  },
  lt: {
    newAgentDraft: 'Naujas agentas · Juodraštis',
    notCreated: 'Dar nesukurta.',
    companyAgent: 'Įmonės agentas',
    personalAgent: 'Asmeninis agentas',
    madeBy: 'Sukūrė {name}',
    adminsManage: '{company} · administratoriai jį tvarko',
    liveAuthor:
      'Versiją {revision} sukūrė {name}. Įjungtas jis veikia jūsų vardu naudodamas jūsų privačius ryšius.',
    runsWhenCreated: 'Jis gali veikti, kai jo savininkas jį sukurs.',
    onDemand: 'Pagal poreikį.',
    onDemandEdit:
      'Jis veikia, kai kas nors jį paleidžia. Tvarkaraštį pridėkite skiltyje „Kada jis veikia“.',
    onDemandRun: 'Jis veikia, kai kas nors jį paleidžia.',
    on: 'Įjungta.',
    nextRun: 'Įjungta. Kitas paleidimas – {date}.',
    pausing: 'Pristabdžius tvarkaraštis nevykdomas. Paleisti dabar vis tiek galima.',
    alsoRun: 'Taip pat galite paleisti dabar.',
    off: 'Išjungta. {schedule} įjungus.',
    offRun: 'Išjungtas jis vis tiek gali būti paleistas dabar.',
    saveCancel: 'Pirmiausia išsaugokite arba atšaukite pakeitimą.',
    draftAuto: 'Šis juodraštis neveikia automatiškai.',
    testFirst: 'Pirmiausia išbandykite jį, kad pamatytumėte tikrą rezultatą.',
    testChat: 'Bandomasis paleidimas vyksta pokalbyje, kurį galite perskaityti tik jūs.',
    copied:
      'Nukopijuota. Tai jūsų kopija su pristabdytu tvarkaraščiu, veikianti naudojant jūsų paskyras.',
    editRequested: 'Pateikta užklausa suteikti redagavimo prieigą',
    switchOff: 'Išjungti',
    archive: 'Archyvuoti',
    draftNotCreated: 'Juodraštis, dar nesukurta',
    waiting: 'Laukiama jūsų patvirtinimo',
    neverRun: 'Niekada nepaleista',
    lastRun: 'Paskutinis paleidimas {date}{failed}',
    lastRunOnly: 'Paskutinis paleidimas{failed}',
    formerMember: 'Buvęs narys',
    namesDeleted:
      '{schedule} · rodomi tik pavadinimai; jo savininko paskyra ištrinta, todėl administratoriai gali jį archyvuoti',
    namesRuns: '{schedule} · rodomi tik pavadinimai; paleidimai ir rezultatai lieka pas {name}',
    thisNotCreated: 'Šis agentas dar nesukurtas. Jis gali veikti, kai jo savininkas jį sukurs.',
    noTestRuns:
      'Bandomųjų paleidimų dar nėra. Bandomasis paleidimas vieną kartą išbando juodraštį pokalbyje, kurį galite perskaityti tik jūs.',
    scheduleSaved: 'Tvarkaraštis išsaugotas.',
    draftSaved: 'Juodraštis išsaugotas.',
    savedVersion: 'Išsaugota kaip versija {version}.',
    onDemandNow: 'Dabar jis veikia pagal poreikį.',
    you: 'Jūs',
    anyoneCanRun: 'Dabar jį gali paleisti bet kuris įmonės {company} narys.',
    youRun: 'Paleidžiate jį tada, kai reikia.',
    alsoCompany: 'Dabar jį taip pat gali paleisti bet kuris įmonės {company} narys.',
  },
  mt: {
    newAgentDraft: 'Aġent ġdid · Abbozz',
    notCreated: 'Għadu ma nħoloqx.',
    companyAgent: 'Aġent tal-kumpanija',
    personalAgent: 'Aġent personali',
    madeBy: 'Magħmul minn {name}',
    adminsManage: '{company} · l-amministraturi jimmaniġġjawh',
    liveAuthor:
      'Il-verżjoni {revision} inkitbet minn {name}. Meta jinxtegħel, jaħdem bħala int bil-konnessjonijiet privati tiegħek.',
    runsWhenCreated: 'Jista’ jaħdem ladarba sidu joħolqu.',
    onDemand: 'Meta mitlub.',
    onDemandEdit: 'Jaħdem meta xi ħadd iħaddmu. Żid skeda taħt Meta jaħdem.',
    onDemandRun: 'Jaħdem meta xi ħadd iħaddmu.',
    on: 'Mixgħul.',
    nextRun: 'Mixgħul. It-tħaddim li jmiss {date}.',
    pausing: 'Il-waqfien iwaqqaf l-iskeda. It-tħaddim issa xorta jaħdem.',
    alsoRun: 'Tista’ wkoll tħaddmu issa.',
    off: 'Mitfi. {schedule} ladarba jinxtegħel.',
    offRun: 'It-tħaddim issa xorta jaħdem meta jkun mitfi.',
    saveCancel: 'L-ewwel issalva jew ikkanċella l-bidla tiegħek.',
    draftAuto: 'Dan l-abbozz ma jaħdimx awtomatikament.',
    testFirst: 'Ittestjah darba biex l-ewwel tara riżultat reali.',
    testChat: 'It-tħaddim tat-test jinsab f’chat li tista’ taqra int biss.',
    copied: 'Ikkupjat. Huwa tiegħek, bi skeda mwaqqfa, u jaħdem bil-kontijiet tiegħek.',
    editRequested: 'Intalab aċċess għall-editjar',
    switchOff: 'Itfi',
    archive: 'Arkivja',
    draftNotCreated: 'Abbozz, għadu ma nħoloqx',
    waiting: 'Jistenna l-approvazzjoni tiegħek',
    neverRun: 'Qatt ma tħaddem',
    lastRun: 'L-aħħar tħaddim {date}{failed}',
    lastRunOnly: 'L-aħħar tħaddim{failed}',
    formerMember: 'Eksmembru',
    namesDeleted:
      '{schedule} · ismijiet biss; il-kont ta’ sidu tħassar, għalhekk l-amministraturi jistgħu jarkivjawh',
    namesRuns: '{schedule} · ismijiet biss; it-tħaddim u r-Riżultati jibqgħu għand {name}',
    thisNotCreated: 'Dan l-aġent għadu ma nħoloqx. Jista’ jaħdem ladarba sidu joħolqu.',
    noTestRuns:
      'Għad m’hemmx tħaddimiet tat-test. It-tħaddim tat-test jipprova l-abbozz darba, f’chat li tista’ taqra int biss.',
    scheduleSaved: 'L-iskeda ġiet salvata.',
    draftSaved: 'L-abbozz ġie salvat.',
    savedVersion: 'Ġie salvat bħala verżjoni {version}.',
    onDemandNow: 'Issa jaħdem meta mitlub.',
    you: 'Int',
    anyoneCanRun: 'Kulħadd f’{company} jista’ jħaddmu issa.',
    youRun: 'Int tħaddmu meta jkollok bżonnu.',
    alsoCompany: 'Kulħadd f’{company} jista’ wkoll iħaddmu issa.',
  },
  pl: {
    newAgentDraft: 'Nowy agent · Wersja robocza',
    notCreated: 'Jeszcze nieutworzony.',
    companyAgent: 'Agent firmowy',
    personalAgent: 'Agent osobisty',
    madeBy: 'Utworzony przez {name}',
    adminsManage: '{company} · administratorzy nim zarządzają',
    liveAuthor:
      'Wersja {revision} została utworzona przez {name}. Po włączeniu działa jako Ty, korzystając z Twoich prywatnych połączeń.',
    runsWhenCreated: 'Można go uruchomić, gdy właściciel go utworzy.',
    onDemand: 'Na żądanie.',
    onDemandEdit: 'Uruchamia się, gdy ktoś go uruchomi. Dodaj harmonogram w sekcji „Kiedy działa”.',
    onDemandRun: 'Uruchamia się, gdy ktoś go uruchomi.',
    on: 'Włączony.',
    nextRun: 'Włączony. Następne uruchomienie: {date}.',
    pausing: 'Wstrzymanie zatrzymuje harmonogram. Opcja „Uruchom teraz” nadal działa.',
    alsoRun: 'Możesz też uruchomić go teraz.',
    off: 'Wyłączony. {schedule} po włączeniu.',
    offRun: 'Opcja „Uruchom teraz” nadal działa, gdy jest wyłączony.',
    saveCancel: 'Najpierw zapisz lub anuluj zmianę.',
    draftAuto: 'Ta wersja robocza nie uruchamia się automatycznie.',
    testFirst: 'Uruchom test raz, aby najpierw zobaczyć rzeczywisty wynik.',
    testChat: 'Uruchomienie testowe odbywa się na czacie, który możesz przeczytać tylko Ty.',
    copied:
      'Skopiowano. Agent należy do Ciebie, ma wstrzymany harmonogram i działa z użyciem Twoich kont.',
    editRequested: 'Poproszono o dostęp do edycji',
    switchOff: 'Wyłącz',
    archive: 'Zarchiwizuj',
    draftNotCreated: 'Wersja robocza, jeszcze nieutworzona',
    waiting: 'Oczekuje na Twoją akceptację',
    neverRun: 'Nigdy nieuruchomiony',
    lastRun: 'Ostatnie uruchomienie: {date}{failed}',
    lastRunOnly: 'Ostatnie uruchomienie{failed}',
    formerMember: 'Były członek',
    namesDeleted:
      '{schedule} · tylko nazwy; konto właściciela zostało usunięte, więc administratorzy mogą je zarchiwizować',
    namesRuns: '{schedule} · tylko nazwy; uruchomienia i Wyniki pozostają przy {name}',
    thisNotCreated:
      'Ten agent nie został jeszcze utworzony. Można go uruchomić, gdy właściciel go utworzy.',
    noTestRuns:
      'Brak uruchomień testowych. Uruchomienie testowe jednorazowo sprawdza wersję roboczą na czacie, który możesz przeczytać tylko Ty.',
    scheduleSaved: 'Harmonogram zapisany.',
    draftSaved: 'Wersja robocza zapisana.',
    savedVersion: 'Zapisano jako wersję {version}.',
    onDemandNow: 'Teraz działa na żądanie.',
    you: 'Ty',
    anyoneCanRun: 'Każdy w {company} może go teraz uruchomić.',
    youRun: 'Uruchamiasz go, gdy go potrzebujesz.',
    alsoCompany: 'Każdy w {company} może go teraz również uruchomić.',
  },
  pt: {
    newAgentDraft: 'Novo agente · Rascunho',
    notCreated: 'Ainda não criado.',
    companyAgent: 'Agente da empresa',
    personalAgent: 'Agente pessoal',
    madeBy: 'Criado por {name}',
    adminsManage: '{company} · gerenciado pelos administradores',
    liveAuthor:
      'A versão {revision} foi criada por {name}. Quando ativada, é executada como você, com suas conexões privadas.',
    runsWhenCreated: 'Ele poderá ser executado assim que o proprietário o criar.',
    onDemand: 'Sob demanda.',
    onDemandEdit:
      'Ele é executado quando alguém o executa. Adicione uma programação em Quando é executado.',
    onDemandRun: 'Ele é executado quando alguém o executa.',
    on: 'Ativado.',
    nextRun: 'Ativado. Próxima execução {date}.',
    pausing: 'Pausar interrompe a programação. Executar agora continua funcionando.',
    alsoRun: 'Você também pode executá-lo agora.',
    off: 'Desativado. {schedule} quando for ativado.',
    offRun: 'Executar agora continua funcionando enquanto estiver desativado.',
    saveCancel: 'Salve ou cancele sua alteração primeiro.',
    draftAuto: 'Este rascunho não é executado automaticamente.',
    testFirst: 'Faça um teste para ver um resultado real primeiro.',
    testChat: 'A execução de teste fica em um chat que só você pode ler.',
    copied:
      'Copiado. Ele é seu, com a programação pausada, e é executado com suas próprias contas.',
    editRequested: 'Acesso para editar solicitado',
    switchOff: 'Desativar',
    archive: 'Arquivar',
    draftNotCreated: 'Rascunho, ainda não criado',
    waiting: 'Aguardando sua aprovação',
    neverRun: 'Nunca executado',
    lastRun: 'Última execução {date}{failed}',
    lastRunOnly: 'Última execução{failed}',
    formerMember: 'Ex-membro',
    namesDeleted:
      '{schedule} · apenas nomes; a conta do proprietário foi excluída, então os administradores podem arquivá-lo',
    namesRuns: '{schedule} · apenas nomes; as execuções e os Resultados permanecem com {name}',
    thisNotCreated:
      'Este agente ainda não foi criado. Ele poderá ser executado assim que o proprietário o criar.',
    noTestRuns:
      'Ainda não há execuções de teste. A execução de teste tenta executar o rascunho uma vez, em um chat que só você pode ler.',
    scheduleSaved: 'Programação salva.',
    draftSaved: 'Rascunho salvo.',
    savedVersion: 'Salvo como versão {version}.',
    onDemandNow: 'Agora ele é executado sob demanda.',
    you: 'Você',
    anyoneCanRun: 'Qualquer pessoa em {company} pode executá-lo agora.',
    youRun: 'Você o executa quando precisar.',
    alsoCompany: 'Qualquer pessoa em {company} também pode executá-lo agora.',
  },
  ro: {
    newAgentDraft: 'Agent nou · Ciornă',
    notCreated: 'Încă nu a fost creat.',
    companyAgent: 'Agent al companiei',
    personalAgent: 'Agent personal',
    madeBy: 'Creat de {name}',
    adminsManage: '{company} · administratorii îl gestionează',
    liveAuthor:
      'Versiunea {revision} a fost scrisă de {name}. Când este activat, rulează ca tine, cu conexiunile tale private.',
    runsWhenCreated: 'Poate rula după ce proprietarul său îl creează.',
    onDemand: 'La cerere.',
    onDemandEdit: 'Rulează când cineva îl rulează. Adaugă un program la secțiunea Când rulează.',
    onDemandRun: 'Rulează când cineva îl rulează.',
    on: 'Activat.',
    nextRun: 'Activat. Următoarea rulare: {date}.',
    pausing: 'Punerea pe pauză oprește programul. Rularea imediată funcționează în continuare.',
    alsoRun: 'Îl poți rula și acum.',
    off: 'Dezactivat. {schedule} după activare.',
    offRun: 'Rularea imediată funcționează în continuare cât timp este dezactivat.',
    saveCancel: 'Salvează sau anulează mai întâi modificarea.',
    draftAuto: 'Această ciornă nu rulează automat.',
    testFirst: 'Testează-l o dată pentru a vedea mai întâi un rezultat real.',
    testChat: 'Rularea de test este disponibilă doar într-un chat pe care îl poți citi doar tu.',
    copied: 'Copiat. Îți aparține, cu un program pus pe pauză, și rulează folosind conturile tale.',
    editRequested: 'Acces de editare solicitat',
    switchOff: 'Dezactivează',
    archive: 'Arhivează',
    draftNotCreated: 'Ciornă, încă necreată',
    waiting: 'Se așteaptă aprobarea ta',
    neverRun: 'Nu a fost rulat niciodată',
    lastRun: 'Ultima rulare {date}{failed}',
    lastRunOnly: 'Ultima rulare{failed}',
    formerMember: 'Fost membru',
    namesDeleted:
      '{schedule} · doar numele; contul proprietarului a fost șters, astfel încât administratorii îl pot arhiva',
    namesRuns: '{schedule} · doar numele; rulările și rezultatele rămân la {name}',
    thisNotCreated:
      'Acest agent nu a fost creat încă. Poate rula după ce proprietarul său îl creează.',
    noTestRuns:
      'Nu există încă rulări de test. Rularea de test încearcă ciorna o dată, într-un chat pe care doar tu îl poți citi.',
    scheduleSaved: 'Program salvat.',
    draftSaved: 'Ciornă salvată.',
    savedVersion: 'Salvat ca versiunea {version}.',
    onDemandNow: 'Acum rulează la cerere.',
    you: 'Tu',
    anyoneCanRun: 'Oricine din {company} îl poate rula acum.',
    youRun: 'Îl rulezi când ai nevoie.',
    alsoCompany: 'Oricine din {company} îl poate rula și acum.',
  },
  sk: {
    newAgentDraft: 'Nový agent · Koncept',
    notCreated: 'Zatiaľ nevytvorené.',
    companyAgent: 'Firemný agent',
    personalAgent: 'Osobný agent',
    madeBy: 'Autor: {name}',
    adminsManage: '{company} · spravujú ho administrátori',
    liveAuthor:
      'Verziu {revision} vytvoril {name}. Po zapnutí beží ako vy s vašimi súkromnými pripojeniami.',
    runsWhenCreated: 'Môže bežať, keď ho jeho vlastník vytvorí.',
    onDemand: 'Na požiadanie.',
    onDemandEdit: 'Spustí sa, keď ho niekto spustí. V časti Kedy sa spúšťa pridajte plán.',
    onDemandRun: 'Spustí sa, keď ho niekto spustí.',
    on: 'Zapnuté.',
    nextRun: 'Zapnuté. Ďalšie spustenie {date}.',
    pausing: 'Pozastavenie zastaví plán. Spustiť teraz bude stále možné.',
    alsoRun: 'Môžete ho spustiť aj teraz.',
    off: 'Vypnuté. {schedule}, keď ho zapnete.',
    offRun: 'Spustiť teraz bude možné aj počas vypnutia.',
    saveCancel: 'Najprv uložte zmenu alebo ju zrušte.',
    draftAuto: 'Tento koncept sa nespúšťa automaticky.',
    testFirst: 'Najprv ho raz otestujte, aby ste videli skutočný výsledok.',
    testChat: 'Testovacie spustenie je v chate, ktorý môžete čítať iba vy.',
    copied: 'Skopírované. Je váš, s pozastaveným plánom, a spúšťa sa s vašimi vlastnými účtami.',
    editRequested: 'Vyžiadaný prístup na úpravu',
    switchOff: 'Vypnúť',
    archive: 'Archivovať',
    draftNotCreated: 'Koncept, zatiaľ nevytvorený',
    waiting: 'Čaká na vaše schválenie',
    neverRun: 'Ešte nikdy nespustené',
    lastRun: 'Posledné spustenie {date}{failed}',
    lastRunOnly: 'Posledné spustenie{failed}',
    formerMember: 'Bývalý člen',
    namesDeleted:
      '{schedule} · iba názvy; účet jeho vlastníka bol odstránený, takže ho administrátori môžu archivovať',
    namesRuns: '{schedule} · iba názvy; spustenia a výsledky zostávajú používateľovi {name}',
    thisNotCreated: 'Tento agent ešte nebol vytvorený. Môže bežať, keď ho jeho vlastník vytvorí.',
    noTestRuns:
      'Zatiaľ žiadne testovacie spustenia. Testovacie spustenie skúsi koncept raz v chate, ktorý môžete čítať iba vy.',
    scheduleSaved: 'Plán uložený.',
    draftSaved: 'Koncept uložený.',
    savedVersion: 'Uložené ako verzia {version}.',
    onDemandNow: 'Teraz sa spúšťa na požiadanie.',
    you: 'Vy',
    anyoneCanRun: 'Ktokoľvek v {company} ho teraz môže spustiť.',
    youRun: 'Spúšťate ho, keď ho potrebujete.',
    alsoCompany: 'Ktokoľvek v {company} ho teraz môže tiež spustiť.',
  },
  sl: {
    newAgentDraft: 'Nov agent · osnutek',
    notCreated: 'Še ni ustvarjen.',
    companyAgent: 'Agent podjetja',
    personalAgent: 'Osebni agent',
    madeBy: 'Ustvaril/-a {name}',
    adminsManage: '{company} · upravljajo ga skrbniki',
    liveAuthor:
      'Različico {revision} je ustvaril/-a {name}. Ko je vklopljena, se izvaja kot vi z vašimi zasebnimi povezavami.',
    runsWhenCreated: 'Zažene se lahko, ko ga ustvari njegov lastnik.',
    onDemand: 'Na zahtevo.',
    onDemandEdit: 'Zažene se, ko ga kdo zažene. Urnik dodajte v razdelku Kdaj se zažene.',
    onDemandRun: 'Zažene se, ko ga kdo zažene.',
    on: 'Vklopljeno.',
    nextRun: 'Vklopljeno. Naslednji zagon {date}.',
    pausing: 'Začasna ustavitev ustavi urnik. Zagon zdaj je še vedno mogoč.',
    alsoRun: 'Zaženete ga lahko tudi zdaj.',
    off: 'Izklopljeno. {schedule}, ko bo vklopljeno.',
    offRun: 'Zagon zdaj je mogoč tudi, ko je izklopljeno.',
    saveCancel: 'Najprej shranite spremembo ali jo prekličite.',
    draftAuto: 'Ta osnutek se ne izvaja samodejno.',
    testFirst: 'Najprej ga enkrat preizkusite, da vidite dejanski rezultat.',
    testChat: 'Poskusno izvajanje je v klepetu, ki ga lahko berete samo vi.',
    copied: 'Kopirano. Je vaše, urnik je začasno ustavljen, izvaja pa se z vašimi računi.',
    editRequested: 'Zahtevan dostop za urejanje',
    switchOff: 'Izklopi',
    archive: 'Arhiviraj',
    draftNotCreated: 'Osnutek, še ni ustvarjen',
    waiting: 'Čaka na vašo odobritev',
    neverRun: 'Še ni bil zagnan',
    lastRun: 'Zadnji zagon {date}{failed}',
    lastRunOnly: 'Zadnji zagon{failed}',
    formerMember: 'Nekdanji član',
    namesDeleted:
      '{schedule} · samo imena; račun lastnika je bil izbrisan, zato ga lahko skrbniki arhivirajo',
    namesRuns: '{schedule} · samo imena; zagoni in rezultati ostanejo pri {name}',
    thisNotCreated: 'Ta agent še ni bil ustvarjen. Zažene se lahko, ko ga ustvari njegov lastnik.',
    noTestRuns:
      'Za zdaj ni poskusnih zagonov. Poskusno izvajanje enkrat zažene osnutek v klepetu, ki ga lahko berete samo vi.',
    scheduleSaved: 'Urnik je shranjen.',
    draftSaved: 'Osnutek je shranjen.',
    savedVersion: 'Shranjeno kot različica {version}.',
    onDemandNow: 'Zdaj se izvaja na zahtevo.',
    you: 'Vi',
    anyoneCanRun: 'Zdaj ga lahko zažene vsakdo v {company}.',
    youRun: 'Zaženete ga, ko ga potrebujete.',
    alsoCompany: 'Zdaj ga lahko zažene tudi vsakdo v {company}.',
  },
  es: {
    newAgentDraft: 'Agente nuevo · Borrador',
    notCreated: 'Aún no se ha creado.',
    companyAgent: 'Agente de la empresa',
    personalAgent: 'Agente personal',
    madeBy: 'Creado por {name}',
    adminsManage: '{company} · los administradores lo gestionan',
    liveAuthor:
      'La versión {revision} fue escrita por {name}. Al activarla, se ejecuta como tú con tus conexiones privadas.',
    runsWhenCreated: 'Puede ejecutarse una vez que su propietario lo cree.',
    onDemand: 'Bajo demanda.',
    onDemandEdit:
      'Se ejecuta cuando alguien lo ejecuta. Añade una programación en Cuándo se ejecuta.',
    onDemandRun: 'Se ejecuta cuando alguien lo ejecuta.',
    on: 'Activado.',
    nextRun: 'Activado. Próxima ejecución {date}.',
    pausing: 'Pausar detiene la programación. Ejecutarlo ahora sigue funcionando.',
    alsoRun: 'También puedes ejecutarlo ahora.',
    off: 'Desactivado. {schedule} cuando se active.',
    offRun: 'Ejecutarlo ahora sigue funcionando mientras esté desactivado.',
    saveCancel: 'Guarda o cancela primero el cambio.',
    draftAuto: 'Este borrador no se ejecuta automáticamente.',
    testFirst: 'Pruébalo una vez para ver primero un resultado real.',
    testChat: 'La ejecución de prueba está en un chat que solo tú puedes leer.',
    copied: 'Copiado. Es tuyo, con la programación pausada, y se ejecuta con tus propias cuentas.',
    editRequested: 'Acceso de edición solicitado',
    switchOff: 'Desactivar',
    archive: 'Archivar',
    draftNotCreated: 'Borrador, aún no creado',
    waiting: 'Pendiente de tu aprobación',
    neverRun: 'Nunca se ha ejecutado',
    lastRun: 'Última ejecución {date}{failed}',
    lastRunOnly: 'Última ejecución{failed}',
    formerMember: 'Exmiembro',
    namesDeleted:
      '{schedule} · solo nombres; se eliminó la cuenta de su propietario, por lo que los administradores pueden archivarlo',
    namesRuns: '{schedule} · solo nombres; las ejecuciones y los Resultados siguen con {name}',
    thisNotCreated:
      'Este agente aún no se ha creado. Puede ejecutarse una vez que su propietario lo cree.',
    noTestRuns:
      'Aún no hay ejecuciones de prueba. La ejecución de prueba intenta ejecutar el borrador una vez, en un chat que solo tú puedes leer.',
    scheduleSaved: 'Programación guardada.',
    draftSaved: 'Borrador guardado.',
    savedVersion: 'Guardado como versión {version}.',
    onDemandNow: 'Ahora se ejecuta bajo demanda.',
    you: 'Tú',
    anyoneCanRun: 'Cualquiera en {company} puede ejecutarlo ahora.',
    youRun: 'Tú lo ejecutas cuando lo necesitas.',
    alsoCompany: 'Cualquiera en {company} también puede ejecutarlo ahora.',
  },
  sv: {
    newAgentDraft: 'Ny agent · Utkast',
    notCreated: 'Inte skapad ännu.',
    companyAgent: 'Företagsagent',
    personalAgent: 'Personlig agent',
    madeBy: 'Skapad av {name}',
    adminsManage: '{company} · administratörer hanterar den',
    liveAuthor:
      'Version {revision} skrevs av {name}. När den är aktiverad körs den som du med dina privata anslutningar.',
    runsWhenCreated: 'Den kan köras när ägaren har skapat den.',
    onDemand: 'På begäran.',
    onDemandEdit: 'Den körs när någon kör den. Lägg till ett schema under När den körs.',
    onDemandRun: 'Den körs när någon kör den.',
    on: 'På.',
    nextRun: 'På. Nästa körning {date}.',
    pausing: 'Pausning stoppar schemat. Kör nu fungerar fortfarande.',
    alsoRun: 'Du kan också köra den nu.',
    off: 'Av. {schedule} när den har aktiverats.',
    offRun: 'Kör nu fungerar fortfarande när den är av.',
    saveCancel: 'Spara eller avbryt ändringen först.',
    draftAuto: 'Det här utkastet körs inte automatiskt.',
    testFirst: 'Testa den en gång för att se ett verkligt resultat först.',
    testChat: 'Testkörningen finns i en chatt som bara du kan läsa.',
    copied: 'Kopierad. Den är din, med ett pausat schema, och körs med dina egna konton.',
    editRequested: 'Redigeringsåtkomst begärd',
    switchOff: 'Stäng av',
    archive: 'Arkivera',
    draftNotCreated: 'Utkast, inte skapad ännu',
    waiting: 'Väntar på ditt godkännande',
    neverRun: 'Har aldrig körts',
    lastRun: 'Senast körd {date}{failed}',
    lastRunOnly: 'Senast körd{failed}',
    formerMember: 'Tidigare medlem',
    namesDeleted:
      '{schedule} · endast namn; ägarens konto har raderats, så administratörer kan arkivera den',
    namesRuns: '{schedule} · endast namn; körningar och resultat finns kvar hos {name}',
    thisNotCreated:
      'Den här agenten har inte skapats ännu. Den kan köras när ägaren har skapat den.',
    noTestRuns:
      'Inga testkörningar ännu. En testkörning provar utkastet en gång i en chatt som bara du kan läsa.',
    scheduleSaved: 'Schema sparat.',
    draftSaved: 'Utkast sparat.',
    savedVersion: 'Sparad som version {version}.',
    onDemandNow: 'Den körs nu på begäran.',
    you: 'Du',
    anyoneCanRun: 'Alla på {company} kan köra den nu.',
    youRun: 'Du kör den när du behöver den.',
    alsoCompany: 'Alla på {company} kan också köra den nu.',
  },
} as const;
export default agentPresentationCopy;
